import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';

import './checkout.css';
import Success from '../successpage/Success';

export default function App({selected, amount, email, phonenumber, name, logo}) {
  const [paymentCompleted, setPaymentCompleted] = useState(null);
    const navigate = useNavigate();

    const paymentStatus = (paid) => {
      if(paid === "successful"){
        setPaymentCompleted(true)
      }
    }

  const config = {
    public_key: "FLWPUBK_TEST-c04df9cdf3c0df622e76d8ff4cbe0759-X",
    tx_ref: Date.now(),
    amount: amount,
    currency: 'NGN',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: email,
      phonenumber: phonenumber,
      name: name,
    },
    customizations: {
      title: selected,
      description: selected,
      logo: logo,
    },
  };

  const handleFlutterPayment = useFlutterwave(config);
  return (
    <div>
      <button
      className='form-btn-checkout'
        onClick={() => {
          handleFlutterPayment({
            callback: (response) => {
               console.log(response);
               if(response.status === "successful"){
                navigate("/sucsessful")

               }
                closePaymentModal() // this will close the modal programmatically
            },
            onClose: () => {},
          });
        }}
      >
       <h3>Make Payment</h3>
      </button>
    </div>
  );
}